import { Link } from "gatsby"
import React from "react"
import Layout from "../templates/layout"
import { graphql } from "gatsby"
import SEO from "../components/seo"

const BlogCard = ({ node }) => {
  return (
    <div>
      <img
        className="rounded mb-2"
        src={node.dataRaw["blog_image"].url}
        alt={node.dataRaw["blog_image"].alt}
      />
      <Link
        to={`/blog/${node.uid}`}
        className="text-base font-semibold max-w-4xl block mb-2 hover:text-blue transition-colors"
      >
        {node.dataRaw["blog_title"][0].text}
      </Link>
      <div className="text-xs">{node["first_publication_date"]}</div>
    </div>
  )
}

export default function Blog({ location, data }) {
  return (
    <>
      <SEO
        title="Bankjoy — Blog"
        description="Bankjoy delivers award-winning banking technology, including mobile banking, online banking, e-statements, online account opening, online loan origination, and conversational AI to banks and credit unions — big and small."
        url="https://bankjoy-headless.vercel.app/blog"
      />
      <Layout location={location} containerClassName="mt-8 md:mt-12 mb-20 max-w-6xl mx-auto">
        <div className="mx-auto px-8 mb-12 md:mb-20">
          <h1 className="text-4xl md:text-6xl mb-2 text-center">
            Behind the Joy
          </h1>
          <p className="text-center ">
            Articles written by our team of digital banking experts.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 md:gap-x-6 gap-y-8 mx-auto max-w-6xl px-8">
          {data.allPrismicBlogPost.edges.map(({ node }, index) => (
            <BlogCard node={node} key={index} />
          ))}
        </div>
      </Layout>
    </>
  )
}

export const query = graphql`
  {
    allPrismicBlogPost {
      edges {
        node {
          first_publication_date(formatString: "DD MMMM, yyyy")
          dataRaw
          uid
        }
      }
    }
  }
`
